<template>
  <v-card>
    <v-row dense>
      <v-col cols="auto">
        <v-card-text class="pr-0">
          <v-avatar>
            <v-img :src="user.avatarUrl" />
          </v-avatar>
        </v-card-text>
      </v-col>
      <v-col>
        <v-card-title>{{ user.fullName }}</v-card-title>
        <v-card-subtitle>
          <div>{{ user.lastActiveDate | normalDateWithTime }}</div>
          <div>{{ user.totalSpend | currency }}</div>
        </v-card-subtitle>
      </v-col>
    </v-row>
    <v-divider />
    <v-tabs
      v-model="tab"
      fixed-tabs
    >
      <v-tab
        v-for="(item, i) in tabs"
        :key="i"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>
    <v-divider />
    <v-card-text>
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="(item, i) in tabs"
          :key="i"
          class="pt-2"
        >
          <UserCardDetails v-if="item.id == 'details'" />
          <UserCardRoles v-if="item.id == 'roles'" />
          <UserCardActions v-if="item.id == 'actions'" />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import UserCardDetails from '@/components/users/detail/card/Details';
import UserCardRoles from '@/components/users/detail/card/Roles';
import UserCardActions from '@/components/users/detail/card/Actions';
export default {
  name: 'UsersCard',
  components: { UserCardDetails, UserCardRoles, UserCardActions },
  data() {
    return {
      tab: 0,
      tabs: [
        { id: 'details', name: 'Details' },
        { id: 'roles', name: 'Roles' },
        { id: 'actions', name: 'Actions' }
      ]
    };
  },
  computed: {
    ...mapGetters({ user: 'users/user' })
  }
};
</script>
